export default "__VITE_ASSET__mngtiQ4b__"